<div class="h-full w-full flex flex-col justify-start overflow-hidden space-y-4">
  <app-admin-options-nav />

  <div class="h-full min-h-0 flex-1 flex flex-col w-full overflow-hidden">
    <div class="h-full min-h-0 flex flex-row gap-4 w-full">
      <aside
        class="w-60 shrink-0 min-h-0 flex flex-col rounded-xl border border-zinc-200 bg-white shadow-sm dark:border-zinc-800 dark:bg-zinc-950"
        aria-label="Branding sections"
      >
        <div class="shrink-0 border-b border-zinc-200 p-3 dark:border-zinc-800">
          <h4 class="m-0 text-sm font-semibold text-primary">Branding</h4>
          <p class="m-0 mt-0.5 text-xs text-secondary">Internal brand assets, emails, and UI</p>
        </div>

        <nav class="flex-1 min-h-0 overflow-y-auto p-2 scrollbar-transparent">
          <ul class="m-0 flex list-none flex-col gap-1 p-0">
            @for (section of sections; track section.id) {
            <li>
              <a
                [routerLink]="getSectionLink(section.id)"
                class="block w-full rounded-lg border px-3 py-2 text-left transition-colors no-underline"
                [class]="getSectionNavClass(section.id)"
                [attr.aria-current]="isSectionSelected(section.id) ? 'page' : null"
              >
                <p class="m-0 text-sm font-medium text-primary">{{ section.label }}</p>
                <p class="m-0 mt-0.5 text-xs text-secondary line-clamp-2">{{ section.description }}</p>
              </a>
            </li>
            }
          </ul>
        </nav>
      </aside>

      <section class="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden rounded-xl border border-zinc-200 bg-white p-4 shadow-sm dark:border-zinc-800 dark:bg-zinc-950">
        <router-outlet />
      </section>
    </div>
  </div>
</div>
